export const EXCLUDE_SYSTEM_AND_ARCHIVED_USERS_FOR_SEARCH_QUERY =
  " -user_type:system -status:archived";
